'use strict';

import _ from 'lodash';

const products = require('ck-core/source/data/products');

module.exports = {
	robloxTrial: {
		href: _.get(CK, 'config.environment.clients.robloxSequencer.address', ''),
		product: products.ROBLOX
	},
	minecraftTrial: {
		href: _.get(CK, 'config.environment.clients.minecraftSequencer.address', ''),
		product: products.MINECRAFT
	}
};
